
const inspectionsModule = {
    namespaced: true,

    state: {
        inspectionStatistic: null,
        inspectionList: [],
        pagination: null,
        currentYear: null, 
        isModal: false,
        loading: false

    },
    mutations: {
        
    },
    actions: {
        fetchInspections: ({ dispatch, commit, rootState }) => {

            return dispatch('v3/API', {
                method: 'inspection',
                data: {
                    action: 'short',
                    method: 'inspection',
                    ogrn: rootState.card?.company?.ogrn || null,
                    inn: rootState.card?.company?.inn || null
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && Object.keys(e?.data?.data ?? {}).length > 0) {
                    commit('setStateObject', { name: 'card.inspections.inspectionStatistic', value: e.data.data }, { root: true })
                }
            }).catch(err => {
                console.error(err.message)
            })
        },
        getInspectionsByYear({ dispatch, commit, rootState }, { year, limit, offset }) {
            commit('setStateObject', { name: 'card.inspections.loading', value: true }, { root:true })
            commit('setStateObject', { name: 'card.inspections.isModal', value: true }, { root:true })
            commit('setStateObject', { name: 'card.inspections.currentYear', value: year }, { root:true })

            return dispatch('v3/API', {
                method: 'inspection',
                data: {
                    action: 'full',
                    ogrn: rootState?.card?.company?.ogrn || null,
                    inn: rootState?.card?.company?.inn || null,
                    year,
                    limit,
                    offset
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.data?.list?.length) {
                    commit('setStateObject', { name: 'card.inspections.inspectionList', value: e.data.data.list }, { root:true })
                    commit('setStateObject', { name: 'card.inspections.pagination', value: e.data.data.pagination }, { root:true })
                    commit('setStateObject', { name: 'card.inspections.loading', value: false }, { root:true })
                } else {
                    commit('setStateObject', { name: 'card.inspections.loading', value: false }, { root:true })
                    commit('setStateObject', { name: 'card.inspections.isModal', value: false }, { root:true })
                }
            }).catch(err => {
                commit('setStateObject', { name: 'card.inspections.loading', value: false }, { root:true })
                commit('setStateObject', { name: 'card.inspections.isModal', value: false }, { root:true })
                console.error(err.message)
            })
        },
        closeModal({ commit }) {
            commit('setStateObject', { name: 'card.inspections.isModal', value: false }, { root:true })
            commit('setStateObject', { name: 'card.inspections.pagination', value: null }, { root:true })
            commit('setStateObject', { name: 'card.inspections.inspectionList', value: [] }, { root:true })
            commit('setStateObject', { name: 'card.inspections.currentYear', value: null }, { root:true })
        }
    },
    getters: {
        years: state => {
            if(state.inspectionStatistic) {
                return Object.keys(state.inspectionStatistic ?? {}).filter(y => !isNaN(parseInt(y)))
            } else {
                return []
            }
        }
    }
}

export default inspectionsModule